<template>
  <print-page hide-footer>
    <template #header>
      <b-row align-h="between" align-v="center">
        <b-col cols="auto">
          <img class="header-img" :src="rest_home.logo_url" />
        </b-col>
        <b-col cols="auto">
          <img class="header-img" :src="require('../../assets/logo.png')" />
        </b-col>
      </b-row>
    </template>

    <ErrorsMessages :errors="errors" class="not-printable" />

    <b-row class="not-printable" align-h="between" align-v="center">
      <b-col cols="auto">
        <v-btn class="v-primary" @click="handleBack()">
          <i class="fa fa-arrow-left mr-1" /> VOLTAR
        </v-btn>
      </b-col>
      <b-col cols="auto">
        <v-btn class="v-primary ml-1" @click="openPrintDialog">
          <i class="fa fa-print mr-1" /> IMPRIMIR
        </v-btn>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <div class="custom-table">
          <b-row no-gutters>
            <b-col>
              CLIENTE <br />
              {{ rest_home.name }}
            </b-col>
            <b-col cols="auto">
              CNPJ <br />
              {{ rest_home.cnpj }}
            </b-col>
          </b-row>
          <b-row no-gutters>
            <b-col>
              ENDEREÇO <br />
              {{ rest_home.address }}
            </b-col>
            <b-col cols="auto">
              NÚMERO <br />
              {{ rest_home.num_address }}
            </b-col>
          </b-row>
          <b-row no-gutters>
            <b-col>
              CEP <br />
              {{ rest_home.cep }}
            </b-col>
            <b-col>
              BAIRRO <br />
              {{ rest_home.neighborhood }}
            </b-col>
            <b-col>
              CIDADE <br />
              {{ rest_home.city }}
            </b-col>
            <b-col>
              ESTADO <br />
              {{ rest_home.uf }}
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <div class="custom-table">
          <b-row no-gutters>
            <b-col cols="auto">
              EMITIDO <br />
              {{ formatDate(now) }}
            </b-col>
            <b-col cols="auto">
              PERÍODO <br />
              {{ formatDate(period.start, false) }} -
              {{ formatDate(period.end, false) }}
            </b-col>
            <b-col cols="auto">
              PAGAMENTO <br />
              {{ formatDate(period.payment_date_start, false) }} -
              {{ formatDate(period.payment_date_end, false) }}
            </b-col>
            <b-col>
              RESIDENTES <br />
              {{ period.residents.length }}
            </b-col>
            <b-col cols="auto">
              VALOR <br />
              {{ formatBRLCurrency(period.payment_value) }}
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <v-data-table
          dense
          :headers="active_resident_headers"
          :items="period.residents"
          hide-default-footer
          disable-pagination
          disable-sort
        >
          <template #[`item.start_date`]="{ item }">
            {{ formatDate(item.start_date, false) }}
          </template>
          <template #[`item.end_date`]="{ item }">
            {{ formatDate(item.end_date, false) }}
          </template>
          <template #[`item.days`]="{ item }">
            {{ item.days.length }}
          </template>
          <template #[`item.total`]="{ item }">
            {{ formatBRLCurrency(item.total) }}
          </template>
          <template #[`body.append`]="{}">
            <tr>
              <td>TOTAL: {{ period.residents.length }}</td>
              <td></td>
              <td></td>
              <td></td>
              <td>TOTAL: {{ formatBRLCurrency(period.payment_value) }}</td>
            </tr>
          </template>
        </v-data-table>
      </b-col>
      <b-col cols="12">
        <div class="custom-table">
          <b-row no-gutters v-if="false">
            <b-col>
              CLIENTE <br />
              {{ rest_home.name }}
            </b-col>
            <b-col cols="auto">
              CNPJ <br />
              {{ rest_home.cnpj }}
            </b-col>
          </b-row>
          <b-row no-gutters v-if="false">
            <b-col cols="auto">
              EMITIDO <br />
              {{ formatDate(now) }}
            </b-col>
            <b-col cols="auto">
              PERÍODO <br />
              {{ formatDate(period.start, false) }} -
              {{ formatDate(period.end, false) }}
            </b-col>
            <b-col cols="auto">
              PAGAMENTO <br />
              {{ formatDate(period.payment_date_start, false) }} -
              {{ formatDate(period.payment_date_end, false) }}
            </b-col>
            <b-col>
              RESIDENTES <br />
              {{ period.residents.length }}
            </b-col>
            <b-col cols="auto">
              VALOR <br />
              {{ formatBRLCurrency(period.payment_value) }}
            </b-col>
          </b-row>
          <b-row no-gutters>
            <b-col cols="auto">
              ENTREGUE <br />
              <span class="data-manual"> ___/___/______ </span>
            </b-col>
            <b-col> ASSINATURA DO CLIENTE <br /> </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>

    <div
      style="padding-top: 100px"
      v-if="period.plans && period.plans.length > 0 && false"
    >
      <div style="page-break-before: always !important">
        <b-row no-gutters>
          <b-col class="text-center"> MÓDULOS </b-col>
        </b-row>
        <b-row>
          <b-col v-for="(item, key) in period.plans" :key="key">
            <div class="custom-table">
              <b-row
                no-gutters
                v-for="(day, key_day) in item.days"
                :key="`${key}-${key_day}`"
              >
                <b-col
                  class="d-flex flex-column align-items-center justify-content-center"
                >
                  <span>{{ formatDate(day.date, false) }}</span>
                  <div class="text-center">
                    <p class="m-0 text-thirteen">
                      {{ item.description }}
                    </p>
                    <span class="mr-2 text-thirteen">
                      R$
                      {{ formatBRLCurrency(String(day.standard_value)) }}
                    </span>
                    <span class="text-thirteen">
                      (min: R$
                      {{ formatBRLCurrency(String(day.start_value)) }})
                    </span>
                  </div>
                </b-col>
                <b-col
                  class="row-day-module"
                  v-for="day_module in day.modules"
                  :key="`${key}-${key_day}-${day_module.id}`"
                >
                  <p class="m-0 text-thirteen">{{ day_module.description }}</p>
                  <span class="mr-2 text-thirteen">
                    R$
                    {{ formatBRLCurrency(String(day_module.standard_value)) }}
                  </span>
                  <span class="text-thirteen">
                    (min: R$
                    {{ formatBRLCurrency(String(day_module.start_value)) }})
                  </span>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>

    <div style="padding-top: 100px" v-if="false">
      <b-row style="page-break-before: always !important">
        <b-col>
          <div class="custom-table">
            <b-row no-gutters>
              <b-col>
                CLIENTE <br />
                {{ rest_home.name }}
              </b-col>
              <b-col cols="auto">
                CNPJ <br />
                {{ rest_home.cnpj }}
              </b-col>
            </b-row>
            <b-row no-gutters>
              <b-col cols="auto">
                EMITIDO <br />
                {{ formatDate(now) }}
              </b-col>
              <b-col cols="auto">
                PERÍODO <br />
                {{ formatDate(period.start, false) }} -
                {{ formatDate(period.end, false) }}
              </b-col>
              <b-col cols="auto">
                PAGAMENTO <br />
                {{ formatDate(period.payment_date_start, false) }} -
                {{ formatDate(period.payment_date_end, false) }}
              </b-col>
              <b-col>
                RESIDENTES <br />
                {{ period.residents.length }}
              </b-col>
              <b-col cols="auto">
                VALOR <br />
                {{ formatBRLCurrency(period.payment_value) }}
              </b-col>
            </b-row>
            <b-row no-gutters>
              <b-col cols="auto">
                ENTREGUE <br />
                <span class="data-manual"> ___/___/______ </span>
              </b-col>
              <b-col> ASSINATURA DO CLIENTE <br /> </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </div>
  </print-page>
</template>

<script>
import ErrorsMessages from "../components/ErrorsMessages";
import { formatBRLCurrency } from "../../lib/functions";
import api from "../../services/api";
import { formatDate } from "../../functions/format";
import PrintPage from "../components/PrintPage.vue";

export default {
  name: "RestHomeCharge",
  components: {
    ErrorsMessages,
    PrintPage,
  },
  data() {
    return {
      errors: [],
      now: new Date(),

      loading: false,
      periods: {},
      p_years: [],
      p_months: [],
      p_periods: [],

      period: {
        residents: [],
        end: "",
        force_charge_per_resident: "",
        payment_date_end: "",
        payment_date_start: "",
        payment_status_id: "",
        payment_status_level: "",
        payment_status_message: "",
        payment_status_name: "",
        payment_status_value: "",
        payment_term_value: "",
        payment_value: "",
        plans: [],
        rest_home_id: "",
        rest_home_name: "",
        start: "",
      },

      years: [],
      year: null,
      months: [
        { name: "JANEIRO", value: 0 },
        { name: "FEVEREIRO", value: 1 },
        { name: "MARÇO", value: 2 },
        { name: "ABRIL", value: 3 },
        { name: "MAIO", value: 4 },
        { name: "JUNHO", value: 5 },
        { name: "JULHO", value: 6 },
        { name: "AGOSTO", value: 7 },
        { name: "SETEMBRO", value: 8 },
        { name: "OUTUBRO", value: 9 },
        { name: "NOVEMBRO", value: 10 },
        { name: "DEZEMBRO", value: 11 },
      ],
      month: 1,
      charge_period: 1,

      rest_home_id: "",

      active_resident_headers: [
        { text: "NOME", value: "name" },
        { text: "DATA INICIAL", value: "start_date" },
        { text: "DATA FINAL", value: "end_date" },
        { text: "DIAS ATIVO", value: "days" },
        { text: "VALOR", value: "total" },
      ],

      rest_home: {},
    };
  },
  created() {
    const { rest_home_id, charge_period } = this.$router.currentRoute.params;

    this.rest_home_id = rest_home_id;
    this.charge_period = charge_period;

    this.retrieve();
  },

  methods: {
    formatBRLCurrency,
    formatDate,

    handleBack() {
      this.$router.push({
        name: "client",
        params: { id: this.rest_home_id },
        query: { tab: "charge" },
      });
    },

    async retrieve() {
      try {
        if (this.errors.length == 0) await this.getRestHome();
        if (this.errors.length == 0) await this.getPeriod();
      } catch (error) {
        console.log(error);
      }
    },

    async openPrintDialog() {
      window.print();
    },

    async getRestHome() {
      try {
        const params = { id: this.rest_home_id };
        const response = await api.get("/admin/rest-home/get", { params });
        const { error, errors, restHome } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.rest_home = restHome;
        }
      } catch (error) {
        console.error(error);
      }
    },

    async getPeriod() {
      try {
        this.loading = true;

        let params = {
          rest_home_id: this.rest_home_id,
          charge_period: this.charge_period,
        };
        let response = await api.get("/admin/rest-home/charge/period", {
          params,
        });
        let { error, errors, period } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.period = period;
          this.period.start = new Date(this.period.start);
          this.period.end = new Date(this.period.end);
          this.period.payment_date_start = new Date(
            this.period.payment_date_start
          );
          this.period.payment_date_end = new Date(this.period.payment_date_end);
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    padding(n) {
      return n < 10 ? `0${n}` : String(n);
    },
  },
};
</script>

<style>
.row-day-module {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.header-img {
  height: 30px;
  object-fit: contain;
}

.border-bottom-2px-dashed {
  width: 100%;
  border-bottom: 2px dashed black;
}

.data-manual {
  font-family: monospace;
  font-size: 20px;
}

.custom-table > .row {
  border-top: 1px solid black;
}
.custom-table > .row:last-child {
  border-bottom: 1px solid black;
}

.custom-table > .row > .col,
.custom-table > .row > .col-auto {
  padding-left: 10px;
  border-left: 1px solid black;
}
.custom-table > .row > .col-auto {
  padding-right: 10px;
}
.custom-table > .row > .col:last-child,
.custom-table > .row > .col-auto:last-child {
  padding-right: 10px;
  border-right: 1px solid black;
}

@media print {
  .not-printable {
    display: none;
  }
}
</style>